export default __webpack_public_path__ + "static/Natural_Light_Indoor_2240kbps-0ebbbdf827e7d684e1712bf53b06360d.avif";